import Swiper from 'swiper/bundle';

const VideoTestimonials = () => {
    const sliders = document.querySelectorAll('.video-testimonials__swiper');
        if (!sliders.length) return;

    sliders.forEach((slider) => {
        if (!(slider instanceof Element)) return;

        // Prevent multiple initialisations
        if (slider.swiper) return;

        new Swiper(slider, {
            slidesPerView: 1.4, // Adjust as needed
            spaceBetween: 0,
            loop: false,
            pagination: {
                el: slider.querySelector('.video-testimonials__pagination'),
                clickable: true,
            },
        });
    });
};

export default VideoTestimonials;
